import { Link as RouterLink } from 'react-router-dom'
import { Breadcrumbs, Link as MuiLink, Typography } from '@mui/material'
import { Home as HomeIcon, NavigateNext as NavigateNextIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import { ROUTES } from '@/utils/constants'

export type Crumb = {
  label: string
  /** Без `to` — последняя, текущая страница */
  to?: string
}

/**
 * Хлебные крошки страницы.
 *
 * Общий компонент, а не разметка на каждой странице: путь «Главная → раздел →
 * объект» повторяется у всех, и десять копий одного `Breadcrumbs` разошлись бы
 * на первой же правке. «Главная» подставляется сама — её ставили все.
 */
export function PageBreadcrumbs({ items }: { items: Crumb[] }) {
  const { t } = useTranslation()

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 1 }}>
      <MuiLink
        component={RouterLink}
        to={ROUTES.DASHBOARD}
        underline="hover"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        {t('dashboard.home')}
      </MuiLink>

      {items.map((item) =>
        item.to === undefined ? (
          <Typography key={item.label} color="text.primary">
            {item.label}
          </Typography>
        ) : (
          <MuiLink key={item.label} component={RouterLink} to={item.to} underline="hover">
            {item.label}
          </MuiLink>
        ),
      )}
    </Breadcrumbs>
  )
}
